<div class="manage-ui-home-container">

  <section class="manage-ui-home-container-titlebar">
    <div class="titlebar-left">
      <h3><i class="fa-regular fa-browser"></i> UI/UX</h3>
      <p>
        Edit your UI, pages and AI visualization
      </p>
    </div>
    <div class="titlebar-right">

      <!-- <button
              nz-button
              nz-tooltip
              [nzTooltipTitle]="'Display data tables'"
              nzType="default"
              nzSize="small"
              class="tables-home-button"
              (click)="onDbHomeButtonClicked()">
        <i class="fa-regular fa-table"></i>&nbsp;All Tables
      </button> -->
    </div>

  </section>

  <div class="ui-management-cards">

    <nz-collapse>
      <nz-collapse-panel class="ai-response-collapse-panel"
                         nzActive="true"
                         nzGhost
                         [nzHeader]="nzCollapseAiHeader">
        <rappider-card-icon-title-description-list [items]="entityCards"
                                                   (cardClick)="onEntityCardCardClicked($event)">
        </rappider-card-icon-title-description-list>
      </nz-collapse-panel>
    </nz-collapse>

    <ng-template #nzCollapseAiHeader>
      <div class="collapse-header-container">
        <h4 class="p-2x title">AI Response and Entity Visualization</h4>
        <p class="title-description">Manage how your data entities are visualized and interacted with in the AI
          assistant
          and database entity viewers</p>
      </div>
    </ng-template>

  </div>

  <div class="ui-management-cards">

    <nz-collapse>
      <nz-collapse-panel class="ui-pages-collapse-panel"
                         nzActive="true"
                         nzGhost
                         [nzHeader]="nzCollapseUiPagesHeader">

        <rappider-card-icon-title-description-list [items]="uiManagementCards?.concat(uiPageCards ?? [])"
                                                   (cardClick)="onUiPageCardCardClicked($event)">
        </rappider-card-icon-title-description-list>
      </nz-collapse-panel>
    </nz-collapse>

    <ng-template #nzCollapseUiPagesHeader>
      <div class="collapse-header-container">
        <h4 class="p-2x title">UI Pages</h4>
        <p class="title-description">Edit the layout and content of your UI pages</p>
      </div>
    </ng-template>


  </div>


</div>
